/**
 * CSS Custom Properties for talkn-card
 *
 * Host projects can override any of these on .talkn-card or a parent element:
 *
 *   .talkn-card {
 *     --talkn-card-width: 350px;
 *     --talkn-card-height: 320px;
 *     --talkn-image-height: 240px;
 *     --talkn-header-height: 50px;
 *     --talkn-order-height: 340px;
 *     --talkn-card-gap: 12px;
 *     --talkn-card-bg: #1a1a2e;
 *     --talkn-font-color: #eee;
 *     --talkn-border-color: #333;
 *     --talkn-border-radius: 16px;
 *     --talkn-shadow-color: rgba(0,0,0,0.3);
 *     --talkn-badge-color: #e74c3c;
 *     --talkn-badge-text: #fff;
 *     --talkn-image-bg: #2a2a3e;
 *     --talkn-tip-bg: rgba(0,0,0,0.5);
 *     --talkn-tip-color: #fff;
 *     --talkn-arrow-bg: rgba(0,0,0,0.3);
 *     --talkn-arrow-bg-hover: rgba(0,0,0,0.6);
 *     --talkn-title-font-size: 16px;
 *     --talkn-title-font-weight: 300;
 *     --talkn-desc-font-size: 90%;
 *     --talkn-hover-scale: 1.05;
 *   }
 */

const baseSize = 8;
const baseMargin = baseSize;
const basePadding = baseSize;
const shadowSize = 16;

const styles = {
  baseSize,
  doubleSize: baseSize * 2,
  tripleSize: baseSize * 3,
  quadSize: baseSize * 4,
  quintSize: baseSize * 5,
  sixSize: baseSize * 6,
  sepSize: baseSize * 7,
  baseMargin,
  doubleMargin: baseMargin * 2,
  tripleMargin: baseMargin * 3,
  quadMargin: baseMargin * 4,
  quintMargin: baseMargin * 5,
  sexMargin: baseMargin * 6,
  sepMargin: baseMargin * 7,
  basePadding,
  doublePadding: basePadding * 2,
  triplePadding: basePadding * 3,
  quadPadding: basePadding * 4,
  quintPadding: basePadding * 5,
  sexPadding: basePadding * 6,
  sepPadding: basePadding * 7,
  shadowSize,
  fontBaseSize: 20,
  fontBaseSpSize: 16,
  fontBaseWeight: 200,
  fontSize: '100%',
  fontWeight: '200',
  lineHeight: '30px',
  borderRadius: baseSize * 2,

  // Article Order
  articleOrderHeight: 290,

  // Article (list)
  articleWidth: 300,
  articleTotalWidth: 300 + baseSize * 2,
  articleCloseHeight: 280,
  articleOpenHeight: 'auto' as const,
  articleOpenScale: 1.05,
  articleShadowColor: '#666',

  // Colors
  fontColor: 'rgb(100, 100, 100)',

  // Shadow
  shadowHorizonBright: `0 ${shadowSize / 2}px ${shadowSize}px 0 rgb(240, 240, 240)`,
};

export default styles;
